module.exports = __webpack_public_path__ + "img/840.70c61051.svg";